import { api } from './api';
import { AuditLog, PaginatedResponse } from '../types';

export const getAuditLogs = async (employeeId: string): Promise<AuditLog[]> => {
  try {
    const response = await api.get(`/audit/${employeeId}`);
    return response.data.data.logs;
  } catch (error) {
    console.error(`Failed to fetch audit logs for employee ${employeeId}:`, error);
    throw error;
  }
};

export interface AuditFilters {
  action?: string[];
  userId?: string;
  employeeId?: string;
  dateRange?: {
    start?: string;
    end?: string;
  };
  searchTerm?: string;
}

export const getAllAuditLogs = async (
  filters: AuditFilters = {},
  page = 1,
  limit = 100
): Promise<PaginatedResponse<AuditLog>> => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    // Add filters
    if (filters.action && filters.action.length > 0) {
      params.append('action', filters.action.join(','));
    }
    if (filters.userId) {
      params.append('userId', filters.userId);
    }
    if (filters.employeeId) {
      params.append('employeeId', filters.employeeId);
    }
    if (filters.dateRange?.start) {
      params.append('startDate', filters.dateRange.start);
    }
    if (filters.dateRange?.end) {
      params.append('endDate', filters.dateRange.end);
    }
    if (filters.searchTerm) {
      params.append('searchTerm', filters.searchTerm);
    }

    const response = await api.get(`/audit?${params.toString()}`);
    return response.data.data;
  } catch (error) {
    console.error('Failed to fetch all audit logs:', error);
    throw error;
  }
};
